<template>
  <div class="disclaimer">
    <small
      >This tool provides estimates intended for use only as a planning guide.
      We do not guarantee its accuracy or applicability to your circumstance,
      and we encourage you to consult a qualified professional, school or
      financial aid office directly for more information. Information within
      this tool is based on a review of government information. College and
      university costs and federal loan data is sourced from the 2023 US
      Department of Education College Scorecard. Majors and career salaries is
      sourced from the 2021 US Census American Community Survey. Data is based
      on 4-year colleges and universities offering a bachelor's degree. Discover
      Student Loans does not offer federal student loans and this resource is
      not affiliated with the Department of Education. We will not share your
      results.
      <a
        href="https://www.discover.com/credit-cards/help-center/discover-terms-of-use.html?ICMPGN=PUB_FTR_DSL_TERMS"
        target="_blank"
        class="btn-link secondary"
        >Terms of Use.</a
      >
    </small>
  </div>
</template>

<script>
export default {
  props: {
    page: String
  }
};
</script>
